<template>
<v-container theme="light">
<v-dialog v-model="loading" persistent width="300">
<v-card class="loading">
<v-card-text class="text-center ">
<v-progress-circular
						color="primary"
						indeterminate
						size="60"
					></v-progress-circular>
					<div class="loadingTxt">
						<h3>Generating PDF</h3>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<div id="pdfContent" v-if="matrixReady">
			<v-row class="contentRow">
				<v-card class="selfassementcard" outlined id="actionPlanRisk">
					<ActionPlanRisk1 :key="matrixId" @row-count="updateRowCount" @ready="onActionPlanReady" />
				</v-card>

				<v-card class="selfassementcard" outlined id="riskMatrixWithTable">
					<RiskmatrixwithtableVue1 :key="matrixId" @row-count="updateRowCount1" @ready="onRiskMatrixReady" />
				</v-card>
				<DashboardRiskScore1
					:key="matrixId"
					:comment="this.comment"
					id="DashboardRiskScore1"
					@ready="onDashboardReady"
				/>
</v-row>
</div>
</v-container>
</template>
 
<script>
import DashboardRiskScore1 from "../components/PDF/DashboardRiskScore.vue"
import ActionPlanRisk1 from "../components/PDF/ActionPlanRisk.vue"
import RiskmatrixwithtableVue1 from "../components/PDF/Riskmatrixwithtable.vue"
import CompanyregAPI from "../api/clients/registration"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import LoadingState from "../consts/LoadingState"
import FilesAPI from "../api/files/files"
 
export default {
	components: {
		DashboardRiskScore1,
		ActionPlanRisk1,
		RiskmatrixwithtableVue1,
	},
	data() {
		return {
			loading: true,
			rowCountActionPlan: 0,
			rowCountRiskmatrixwithtable: 0,
			rowCountSelfAssessment: 0,
			comment: "",
			companyRegistrationNumber: "",
			matrixId: null,
			matrixReady: false,
			readyFlags: {
				actionPlan: false,
				riskMatrix: false,
				dashboard: false,
			},
			pdfStarted: false,
		}
	},
	methods: {
		updateRowCount(count) {
			this.rowCountActionPlan = count
		},
		updateRowCount1(count) {
			this.rowCountRiskmatrixwithtable = count
		},
		updateRowCount2(count) {
			this.rowCountSelfAssessment = count
		},
		onActionPlanReady() {
			this.readyFlags.actionPlan = true
			this.checkAllReady()
		},
		onRiskMatrixReady() {
			this.readyFlags.riskMatrix = true
			this.checkAllReady()
		},
		onDashboardReady() {
			this.readyFlags.dashboard = true
			this.checkAllReady()
		},
		checkAllReady() {
			const { actionPlan, riskMatrix, dashboard } = this.readyFlags
			if (actionPlan && riskMatrix && dashboard) {
				if (this._fallbackTimer) {
					clearTimeout(this._fallbackTimer)
					this._fallbackTimer = null
				}
				window.scrollTo(0, document.body.scrollHeight)
				setTimeout(() => {
					this.downloadPdf()
				}, 1000)
			}
		},
		initFromQuery() {
			const query = this.$route.query
			const urlParams = new URLSearchParams(window.location.search)
			const matrixId = query.matrixId || urlParams.get("matrixId")
			const title = query.title || urlParams.get("title")
			this.comment = query.comment || urlParams.get("comment") || ""
			this.matrixId = matrixId

			if (matrixId) {
				this.$store.commit("setSelectedId", matrixId)
			}
			if (title) {
				this.$store.commit("setSelectedTitle", title)
			}

			this.matrixReady = !!matrixId
			console.log("Title:", title)
			console.log("matrixId:", matrixId)
			console.log("comment:", this.comment)
		},
		getCurrentDate() {
			const today = new Date()
			const year = today.getFullYear()
			const month = String(today.getMonth() + 1).padStart(2, "0")
			const day = String(today.getDate()).padStart(2, "0")
			return `${year}/${month}/${day}`
		},
		async addHeaderFooter(pdf, pageNumber, totalPages) {
			const footerHeight = 30
			const headerImage = require("../assets/Logo_Header.png")
 
			const img = new Image()
			img.src = headerImage
			await new Promise((resolve) => {
				img.onload = resolve
			})
 
			const imgWidth = 80
			const imgHeight = 18
			const headerY = 20
 
			pdf.setFontSize(10)
			const textX = 30
			const textY = headerY + imgHeight / 2 + 3
 
			pdf.text("Created By ", textX, textY)
 
			const imageX = textX + pdf.getTextWidth("Created By") + 5
			pdf.addImage(img, "PNG", imageX, headerY, imgWidth, imgHeight)
 
			const dateText = this.getCurrentDate()
			const dateTextWidth = pdf.getTextWidth(dateText)
			const dateTextX = pdf.internal.pageSize.getWidth() - dateTextWidth - 70
			pdf.text(dateText, dateTextX, textY)
 
			const startX = 40
			const endX = pdf.internal.pageSize.getWidth() - 40
			const gradientWidth = (endX - startX) / 2
			const lineWidth = 1
			const lineY = headerY + imgHeight + 10
 
			for (let i = 0; i <= gradientWidth; i = i + 0.5) {
				const opacity = i / gradientWidth
				pdf.setDrawColor(0, 0, 0, opacity)
				pdf.setLineWidth(lineWidth)
				pdf.line(startX + i, lineY, startX + i, lineY + lineWidth)
				pdf.line(endX - i, lineY, endX - i, lineY + lineWidth)
			}
 
			const footerY = pdf.internal.pageSize.getHeight() - footerHeight - 10
			const footerLineY = footerY - 10
 
			for (let i = 0; i <= gradientWidth; i = i + 0.3) {
				const opacity = i / gradientWidth
				pdf.setDrawColor(0, 0, 0, opacity)
				pdf.setLineWidth(lineWidth)
				pdf.line(startX + i, footerLineY, startX + i, footerLineY + lineWidth)
				pdf.line(endX - i, footerLineY, endX - i, footerLineY + lineWidth)
			}
 
			pdf.text(
				`Page ${pageNumber} of ${totalPages}`,
				pdf.internal.pageSize.getWidth() / 2,
				pdf.internal.pageSize.getHeight() - footerHeight,
				{ align: "center" }
			)
		},
 
		async createFrontPage(pdf) {
			pdf.setFontSize(22)
			pdf.setTextColor(40)
			pdf.text(
				"Sustainability Summary Report",
				pdf.internal.pageSize.getWidth() / 2,
				100,
				{
					align: "center",
				}
			)
 
			let logoUrl = this.$store.getters["user/getUser"].companyLogo
 
			if (logoUrl && logoUrl.trim() !== "" && logoUrl !== "null") {
				const img = new Image()
				img.src = logoUrl
				await new Promise((resolve) => {
					img.onload = resolve
					img.onerror = () => {
						console.error("Image failed to load:", img.src)
						resolve()
					}
				})
				const imgWidth = 150
				const imgHeight = 150
				pdf.addImage(
					img,
					"JPEG",
					(pdf.internal.pageSize.getWidth() - imgWidth) / 2,
					150,
					imgWidth,
					imgHeight
				)
			} else {
				pdf.setFontSize(16)
				pdf.setTextColor(0, 0, 0)
				pdf.text(
					"",
					pdf.internal.pageSize.getWidth() / 2,
					230,
					{ align: "center" }
				)
			}
 
			pdf.setFontSize(14)
			const rightX = pdf.internal.pageSize.getWidth() - 220
			pdf.text(
				"Company Name: " + this.$store.getters["user/getUser"].clientName,
				rightX,
				pdf.internal.pageSize.getHeight() - 100
			)
 
			const createdDate = this.getCurrentDate()
			pdf.text(
				`Created: ${createdDate}`,
				rightX,
				pdf.internal.pageSize.getHeight() - 80
			)
 
			const headerImage = require("../assets/Logo_Header.png")
			const imgFooter = new Image()
			imgFooter.src = headerImage
			await new Promise((resolve) => {
				imgFooter.onload = resolve
			})
 
			const imgFooterWidth = 40
			const imgFooterHeight = 8
			const marginTop = 20
			const footerY = pdf.internal.pageSize.getHeight() - 40 - marginTop
 
			pdf.setFontSize(10)
			const footerText = "Created By"
			const textWidth = pdf.getTextWidth(footerText)
			const footerX =
				(pdf.internal.pageSize.getWidth() - (textWidth + imgFooterWidth + 5)) / 2
 
			pdf.text(footerText, footerX, footerY)
 
			const imgX = footerX + textWidth + 5
			pdf.addImage(
				imgFooter,
				"PNG",
				imgX,
				footerY - imgFooterHeight + 2,
				imgFooterWidth,
				imgFooterHeight
			)
		},
 
		async downloadPdf() {
			if (this.pdfStarted) return
			this.pdfStarted = true
 
			try {
				let orientation = "l"
				let paper = "a4"
				if (
					this.rowCountActionPlan >= 11 ||
					this.rowCountRiskmatrixwithtable >= 11
				) {
					orientation = "p"
					paper = "a3"
				}
				const pdf = new jsPDF(orientation, "pt", paper)
				const contentWidth = pdf.internal.pageSize.getWidth() - 40
				await this.createFrontPage(pdf)
				pdf.addPage()
				const components = [
					{ id: "DashboardRiskScore1", width: contentWidth },
					{ id: "riskMatrixWithTable", width: contentWidth },
					{ id: "actionPlanRisk", width: contentWidth },
				]
				for (let i = 0; i < components.length; i++) {
					const component = components[i]
					const element = document.getElementById(component.id)
					const canvas = await html2canvas(element, {
						backgroundColor: "#ffffff",
						useCORS: true,
						allowTaint: true,
						scale: 2,
						logging: false,
						width: element.scrollWidth,
						height: element.scrollHeight,
						windowWidth: element.scrollWidth,
						windowHeight: element.scrollHeight,
					})
					const imgData = canvas.toDataURL("image/png")
					const lineY = 70
					const width = component.width
					const height = (canvas.height / canvas.width) * width

					if (i !== 0) {
						pdf.addPage()
					}
 
					await this.addHeaderFooter(pdf, i + 1, components.length)
 
					const pageWidth = pdf.internal.pageSize.getWidth()
					const xOffset = (pageWidth - width) / 2
 
					const componentY = lineY + 20
 
					pdf.addImage(imgData, "PNG", xOffset, componentY, width, height)
				}
				pdf.save("Sustainability Summary Report.pdf")
				setTimeout(() => {
					if (window.opener) {
						window.close()
					} else {
						this.$router.push({ name: "dashboard" })
					}
				}, 500)
			} catch (err) {
				console.error("PDF generation failed:", err)
			} finally {
				this.loading = false
			}
		},
		viewFile() {
			return FilesAPI.getFiledata()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					console.log("Photo", data)
					console.log("Photo", this.$store.getters["user/getUser"].companyLogo)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
 
		getRegistrationDetails() {
			return CompanyregAPI.getRegistration()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.companyRegistrationNumber = data[0].number
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
	beforeMount() {
		this.initFromQuery()
	},
	async mounted() {
		if (!this.matrixReady) {
			this.loading = false
			console.error("PDF generation aborted: missing matrixId")
			return
		}

		await this.getRegistrationDetails()
		await this.viewFile()
		await this.$nextTick()
 
		this._fallbackTimer = setTimeout(() => {
			if (!this.pdfStarted) {
				window.scrollTo(0, document.body.scrollHeight)
				this.downloadPdf()
			}
		}, 8000)
	},
	beforeDestroy() {
		if (this._fallbackTimer) clearTimeout(this._fallbackTimer)
	},
}
</script>
 
<style>
.selfassementcard {
	margin: 10px;
	width: 100%;
}
 
.savebutton {
	margin-top: 20px;
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
}
 
.commenttext {
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin: 20px;
}
 
.commentclass {
	height: 100px;
	max-height: 200px;
	font-size: 1rem;
	resize: vertical;
	width: 100%;
}
 
.dashdivcontainer {
	width: 100%;
}

#pdfContent {
	min-width: 1200px;
}

.loading {
	padding-top: 24px;
}
 
.loadingTxt {
	color: #217b7f;
	margin-top: 20px;
}
 
</style>